<template>
    <nav class="navbar">
        <div class="container-fluid">
            <div class="d-flex align-items-center justify-content-between row no-gutters flex-grow-1">

                <div class="d-none d-lg-block col-2">
                    <router-link to="/"><img src="@/assets/icons/logo.svg" class="img-fluid logo"></router-link>
                </div>
              <div class="d-block d-lg-none col-2">
                <img src="@/assets/icons/menu-mobile.svg" class="img-fluid menu__icon" v-on:click="showSideNav = true;">
              </div>

            </div>
        </div>
        <div class="toggle__navbar" :class="{'active': showSideNav == true}">
          <img src="@/assets/icons/close--white.svg" class="img-fluid close__nav" v-on:click="showSideNav = false;">
          <div class="sidebar">
            <div class="position-relative d-flex flex-column align-items-center">
              <div class="nav__text">
                <div class="nav__point--text" :class="{'active' : activeHover == 0}" v-on:click="moveToSection(1, 0)" v-html="$t('GLOBAL_MENU_01')"></div>
                <div class="nav__point--text" :class="{'active' : activeHover == 1}" v-on:click="moveToSection(4, 0)"  v-html="$t('GLOBAL_MENU_02')"></div>
                <div class="nav__point--text" :class="{'active' : activeHover == 2}" v-on:click="moveToSection(5, 0)"  v-html="$t('GLOBAL_MENU_03')"></div>
                <div class="nav__point--text" :class="{'active' : activeHover == 3}" v-on:click="moveToSection(6, 0)"  v-html="$t('GLOBAL_MENU_04')"></div>
                <div class="nav__point--text" :class="{'active' : activeHover == 4}" v-on:click="moveToSection(7, 0)"  v-html="$t('GLOBAL_MENU_05')"></div>
                <div class="nav__point--text" :class="{'active' : activeHover == 5}" v-html="$t('GLOBAL_CLOSE')" v-on:click="closeModule"></div>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="56" height="360" viewBox="0 0 56 360">
                <defs>
                  <filter id="Linie_1" x="8" y="96" width="40" height="92" filterUnits="userSpaceOnUse">
                    <feOffset dy="4" input="SourceAlpha"/>
                    <feGaussianBlur stdDeviation="6" result="blur"/>
                    <feFlood flood-opacity="0.247"/>
                    <feComposite operator="in" in2="blur"/>
                    <feComposite in="SourceGraphic"/>
                  </filter>
                  <filter id="Linie_4" x="8" y="20" width="40" height="92" filterUnits="userSpaceOnUse">
                    <feOffset dy="4" input="SourceAlpha"/>
                    <feGaussianBlur stdDeviation="6" result="blur-2"/>
                    <feFlood flood-opacity="0.247"/>
                    <feComposite operator="in" in2="blur-2"/>
                    <feComposite in="SourceGraphic"/>
                  </filter>
                  <filter id="Linie_2" x="8" y="172" width="40" height="92" filterUnits="userSpaceOnUse">
                    <feOffset dy="4" input="SourceAlpha"/>
                    <feGaussianBlur stdDeviation="6" result="blur-3"/>
                    <feFlood flood-opacity="0.247"/>
                    <feComposite operator="in" in2="blur-3"/>
                    <feComposite in="SourceGraphic"/>
                  </filter>
                  <filter id="Linie_3" x="8" y="248" width="40" height="92" filterUnits="userSpaceOnUse">
                    <feOffset dy="4" input="SourceAlpha"/>
                    <feGaussianBlur stdDeviation="6" result="blur-4"/>
                    <feFlood flood-opacity="0.247"/>
                    <feComposite operator="in" in2="blur-4"/>
                    <feComposite in="SourceGraphic"/>
                  </filter>
                  <filter id="Ellipse_5" x="0" y="304" width="56" height="56" filterUnits="userSpaceOnUse">
                    <feOffset dy="4" input="SourceAlpha"/>
                    <feGaussianBlur stdDeviation="6" result="blur-5"/>
                    <feFlood flood-opacity="0.247"/>
                    <feComposite operator="in" in2="blur-5"/>
                    <feComposite in="SourceGraphic"/>
                  </filter>
                  <filter id="Ellipse_5-2" x="0" y="228" width="56" height="56" filterUnits="userSpaceOnUse">
                    <feOffset dy="4" input="SourceAlpha"/>
                    <feGaussianBlur stdDeviation="6" result="blur-6"/>
                    <feFlood flood-opacity="0.247"/>
                    <feComposite operator="in" in2="blur-6"/>
                    <feComposite in="SourceGraphic"/>
                  </filter>
                  <filter id="Ellipse_5-3" x="0" y="152" width="56" height="56" filterUnits="userSpaceOnUse">
                    <feOffset dy="4" input="SourceAlpha"/>
                    <feGaussianBlur stdDeviation="6" result="blur-7"/>
                    <feFlood flood-opacity="0.247"/>
                    <feComposite operator="in" in2="blur-7"/>
                    <feComposite in="SourceGraphic"/>
                  </filter>
                  <filter id="Ellipse_5-4" x="0" y="76" width="56" height="56" filterUnits="userSpaceOnUse">
                    <feOffset dy="4" input="SourceAlpha"/>
                    <feGaussianBlur stdDeviation="6" result="blur-8"/>
                    <feFlood flood-opacity="0.247"/>
                    <feComposite operator="in" in2="blur-8"/>
                    <feComposite in="SourceGraphic"/>
                  </filter>
                  <filter id="Ellipse_5-5" x="0" y="0" width="56" height="56" filterUnits="userSpaceOnUse">
                    <feOffset dy="4" input="SourceAlpha"/>
                    <feGaussianBlur stdDeviation="6" result="blur-9"/>
                    <feFlood flood-opacity="0.247"/>
                    <feComposite operator="in" in2="blur-9"/>
                    <feComposite in="SourceGraphic"/>
                  </filter>
                </defs>
                <g id="scrollspy" transform="translate(-186 -287)">
                  <g id="line">
                    <g transform="matrix(1, 0, 0, 1, 186, 287)" filter="url(#Linie_1)">
                      <line id="Linie_1-2" data-name="Linie 1" y1="56" transform="translate(28 110)" fill="none" stroke="#ff9d00" stroke-width="4"/>
                    </g>
                    <g transform="matrix(1, 0, 0, 1, 186, 287)" filter="url(#Linie_4)">
                      <line id="Linie_4-2" data-name="Linie 4" y1="56" transform="translate(28 34)" fill="none" stroke="#ff9d00" stroke-width="4"/>
                    </g>
                    <g transform="matrix(1, 0, 0, 1, 186, 287)" filter="url(#Linie_2)">
                      <line id="Linie_2-2" data-name="Linie 2" y1="56" transform="translate(28 186)" fill="none" stroke="#ff9d00" stroke-width="4"/>
                    </g>
                    <g transform="matrix(1, 0, 0, 1, 186, 287)" filter="url(#Linie_3)">
                      <line id="Linie_3-2" data-name="Linie 3" y1="56" transform="translate(28 262)" fill="none" stroke="#ff9d00" stroke-width="4"/>
                    </g>
                  </g>
                  <g class="nav__item nav__item_05" :class="{'active': highlightIndex == 6 || highlightIndex == 7}"  @mouseover="setActive(4)" @mouseout="resetActive()" v-on:click="moveToSection(7, 0)" id="nav__item-05" transform="translate(0 304)">

                    <g class="active__state" id="Gruppe_29" data-name="Gruppe 29" transform="translate(114 211)">
                      <g id="Ellipse_5-6" data-name="Ellipse 5" transform="translate(204 301)" fill="#ff9d00" stroke="#ff9d00" stroke-width="4">
                        <circle cx="10" cy="10" r="10" stroke="none"/>
                        <circle cx="10" cy="10" r="8" fill="none"/>
                      </g>
                      <line id="Linie_5" data-name="Linie 5" y1="6" transform="translate(100 81)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_6" data-name="Linie 6" y1="6" transform="translate(113.435 86.565) rotate(45)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_7" data-name="Linie 7" y1="6" transform="translate(119 100) rotate(90)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_8" data-name="Linie 8" y1="6" transform="translate(113.435 113.435) rotate(135)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_9" data-name="Linie 9" y1="6" transform="translate(100 119) rotate(180)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_10" data-name="Linie 10" y1="6" transform="translate(86.565 113.435) rotate(-135)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_11" data-name="Linie 11" y1="6" transform="translate(81 100) rotate(-90)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_12" data-name="Linie 12" y1="6" transform="translate(86.565 86.565) rotate(-45)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <g id="Ellipse_5-18" data-name="Ellipse 5" transform="translate(90 90)" fill="#ff9d00" stroke="#ff9d00" stroke-width="4">
                        <circle cx="10" cy="10" r="10" stroke="none"/>
                        <circle cx="10" cy="10" r="8" fill="none"/>
                      </g>
                    </g>
                    <g id="nav__01" transform="translate(204 301)">
                      <g transform="matrix(1, 0, 0, 1, -18, -318)" filter="url(#Ellipse_5)">
                        <g id="Ellipse_5-7" data-name="Ellipse 5" transform="translate(18 318)" fill="none" stroke="#ff9d00" stroke-width="4">
                          <circle cx="10" cy="10" r="10" stroke="none"/>
                          <circle cx="10" cy="10" r="8" fill="none"/>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g class="nav__item nav__item_04" :class="{'active': highlightIndex == 5}" @mouseover="setActive(3)" @mouseout="resetActive()" v-on:click="moveToSection(6, 0)" id="nav__item-04" transform="translate(0 228)">

                    <g class="active__state" id="Gruppe_29-3" data-name="Gruppe 29" transform="translate(114 211)">
                      <g id="Ellipse_5-9" data-name="Ellipse 5" transform="translate(204 301)" fill="#ff9d00" stroke="#ff9d00" stroke-width="4">
                        <circle cx="10" cy="10" r="10" stroke="none"/>
                        <circle cx="10" cy="10" r="8" fill="none"/>
                      </g>
                      <line id="Linie_5-3" data-name="Linie 5" y1="6" transform="translate(100 81)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_6-3" data-name="Linie 6" y1="6" transform="translate(113.435 86.565) rotate(45)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_7-3" data-name="Linie 7" y1="6" transform="translate(119 100) rotate(90)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_8-3" data-name="Linie 8" y1="6" transform="translate(113.435 113.435) rotate(135)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_9-3" data-name="Linie 9" y1="6" transform="translate(100 119) rotate(180)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_10-3" data-name="Linie 10" y1="6" transform="translate(86.565 113.435) rotate(-135)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_11-3" data-name="Linie 11" y1="6" transform="translate(81 100) rotate(-90)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_12-3" data-name="Linie 12" y1="6" transform="translate(86.565 86.565) rotate(-45)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <g id="Ellipse_5-18" data-name="Ellipse 5" transform="translate(90 90)" fill="#ff9d00" stroke="#ff9d00" stroke-width="4">
                        <circle cx="10" cy="10" r="10" stroke="none"/>
                        <circle cx="10" cy="10" r="8" fill="none"/>
                      </g>
                    </g>
                    <g id="nav__04" transform="translate(204 301)">
                      <g transform="matrix(1, 0, 0, 1, -18, -242)" filter="url(#Ellipse_5-2)">
                        <g id="Ellipse_5-10" data-name="Ellipse 5" transform="translate(18 242)" fill="none" stroke="#ff9d00" stroke-width="4">
                          <circle cx="10" cy="10" r="10" stroke="none"/>
                          <circle cx="10" cy="10" r="8" fill="none"/>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g class="nav__item nav__item_03" :class="{'active': highlightIndex == 4}" @mouseover="setActive(2)" @mouseout="resetActive()" v-on:click="moveToSection(5, 0)" id="nav__item-03" transform="translate(0 152)">

                    <g class="active__state" id="Gruppe_29-5" data-name="Gruppe 29" transform="translate(114 211)">
                      <g id="Ellipse_5-12" data-name="Ellipse 5" transform="translate(204 301)" fill="#ff9d00" stroke="#ff9d00" stroke-width="4">
                        <circle cx="10" cy="10" r="10" stroke="none"/>
                        <circle cx="10" cy="10" r="8" fill="none"/>
                      </g>
                      <line id="Linie_5-5" data-name="Linie 5" y1="6" transform="translate(100 81)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_6-5" data-name="Linie 6" y1="6" transform="translate(113.435 86.565) rotate(45)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_7-5" data-name="Linie 7" y1="6" transform="translate(119 100) rotate(90)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_8-5" data-name="Linie 8" y1="6" transform="translate(113.435 113.435) rotate(135)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_9-5" data-name="Linie 9" y1="6" transform="translate(100 119) rotate(180)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_10-5" data-name="Linie 10" y1="6" transform="translate(86.565 113.435) rotate(-135)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_11-5" data-name="Linie 11" y1="6" transform="translate(81 100) rotate(-90)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_12-5" data-name="Linie 12" y1="6" transform="translate(86.565 86.565) rotate(-45)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <g id="Ellipse_5-18" data-name="Ellipse 5" transform="translate(90 90)" fill="#ff9d00" stroke="#ff9d00" stroke-width="4">
                        <circle cx="10" cy="10" r="10" stroke="none"/>
                        <circle cx="10" cy="10" r="8" fill="none"/>
                      </g>
                    </g>
                    <g id="nav__03" transform="translate(204 301)">
                      <g transform="matrix(1, 0, 0, 1, -18, -166)" filter="url(#Ellipse_5-3)">
                        <g id="Ellipse_5-13" data-name="Ellipse 5" transform="translate(18 166)" fill="none" stroke="#ff9d00" stroke-width="4">
                          <circle cx="10" cy="10" r="10" stroke="none"/>
                          <circle cx="10" cy="10" r="8" fill="none"/>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g class="nav__item nav__item_02" :class="{'active': highlightIndex == 3}"  @mouseover="setActive(1)" @mouseout="resetActive()" v-on:click="moveToSection(4, 0)" id="nav__item-02" transform="translate(0 76)">

                    <g class="active__state" id="Gruppe_29-7" data-name="Gruppe 29" transform="translate(114 211)">

                      <line id="Linie_5-7" data-name="Linie 5" y1="6" transform="translate(100 81)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_6-7" data-name="Linie 6" y1="6" transform="translate(113.435 86.565) rotate(45)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_7-7" data-name="Linie 7" y1="6" transform="translate(119 100) rotate(90)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_8-7" data-name="Linie 8" y1="6" transform="translate(113.435 113.435) rotate(135)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_9-7" data-name="Linie 9" y1="6" transform="translate(100 119) rotate(180)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_10-7" data-name="Linie 10" y1="6" transform="translate(86.565 113.435) rotate(-135)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_11-7" data-name="Linie 11" y1="6" transform="translate(81 100) rotate(-90)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_12-7" data-name="Linie 12" y1="6" transform="translate(86.565 86.565) rotate(-45)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <g id="Ellipse_5-18" data-name="Ellipse 5" transform="translate(90 90)" fill="#ff9d00" stroke="#ff9d00" stroke-width="4">
                        <circle cx="10" cy="10" r="10" stroke="none"/>
                        <circle cx="10" cy="10" r="8" fill="none"/>
                      </g>
                    </g>
                    <g id="nav__04-2" data-name="nav__04" transform="translate(204 301)">
                      <g transform="matrix(1, 0, 0, 1, -18, -90)" filter="url(#Ellipse_5-4)">
                        <g id="Ellipse_5-16" data-name="Ellipse 5" transform="translate(18 90)" fill="none" stroke="#ff9d00" stroke-width="4">
                          <circle cx="10" cy="10" r="10" stroke="none"/>
                          <circle cx="10" cy="10" r="8" fill="none"/>
                        </g>
                      </g>
                    </g>
                  </g>
                  <g class="nav__item nav__item_01" :class="{'active': highlightIndex == 1 || highlightIndex == 0 || highlightIndex == 2}" @mouseover="setActive(0)" @mouseout="resetActive()" v-on:click="moveToSection(1, 0)"  id="nav__item-01" transform="translate(0 -82)">
                    <g class="active__state" id="Gruppe_29-9" data-name="Gruppe 29" transform="translate(114 293)">
                      <line id="Linie_5-9" data-name="Linie 5" y1="6" transform="translate(100 81)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_6-9" data-name="Linie 6" y1="6" transform="translate(113.435 86.565) rotate(45)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_7-9" data-name="Linie 7" y1="6" transform="translate(119 100) rotate(90)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_8-9" data-name="Linie 8" y1="6" transform="translate(113.435 113.435) rotate(135)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_9-9" data-name="Linie 9" y1="6" transform="translate(100 119) rotate(180)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_10-9" data-name="Linie 10" y1="6" transform="translate(86.565 113.435) rotate(-135)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_11-9" data-name="Linie 11" y1="6" transform="translate(81 100) rotate(-90)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <line id="Linie_12-9" data-name="Linie 12" y1="6" transform="translate(86.565 86.565) rotate(-45)" fill="none" stroke="#ff9d00" stroke-linecap="round" stroke-width="2"/>
                      <g id="Ellipse_5-18" data-name="Ellipse 5" transform="translate(90 90)" fill="#ff9d00" stroke="#ff9d00" stroke-width="4">
                        <circle cx="10" cy="10" r="10" stroke="none"/>
                        <circle cx="10" cy="10" r="8" fill="none"/>
                      </g>
                    </g>
                    <g transform="matrix(1, 0, 0, 1, 186, 369)" filter="url(#Ellipse_5-5)">
                      <g id="Ellipse_5-19" data-name="Ellipse 5" transform="translate(18 14)" fill="none" stroke="#ff9d00" stroke-width="4">
                        <circle cx="10" cy="10" r="10" stroke="none"/>
                        <circle cx="10" cy="10" r="8" fill="none"/>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
              <img src="@/assets/icons/close--yellow.svg" class="img-fluid sidebar__close" v-on:click="closeModule" @mouseover="setActive(5)" @mouseout="resetActive()">
            </div>
          </div>
        </div>
    </nav>
</template>

<script>
    import { EventBus } from '@/main';
    import { gsap, TimelineMax, CSSPlugin } from 'gsap/all'

    gsap.registerPlugin(CSSPlugin)

    export default {
        name: "Navigation",
        components: {
            EventBus
        },
        data(){
            return {
                sites: "",
                timeline: '',
                sound: '',
                soundPlaying: false,
              showSideNav: false,
              lang: "",
              country: "",
              activeHover: -1,
              active: 1,
              highlightIndex: 0,
            }
        },
      watch: {
        '$store.state.currentNav': function() {
          this.active = this.$store.state.currentNav;
          this.highlightIndex = this.$store.state.currentNav;
          console.log(this.$store.state.currentNav)
        }
      },
        methods: {
            getKapitel(kapitel){
                return "0"+kapitel;
            },
            toggleSound() {
                if (this.soundPlaying) {
                    this.sound.pause()
                } else {
                    this.sound.play();
                }
                this.soundPlaying = !this.soundPlaying;
            },
            pauseSound(keyword) {
                console.log(keyword, this.soundPlaying);
                if (this.soundPlaying) {
                    if (keyword == 'play') {
                        this.sound.play()
                    } else if (keyword == 'pause') {
                        this.sound.pause();
                    }
                }
            },
            openNav(){
                const trigger = document.querySelector('#navbarNav').classList
                if (trigger.contains('show')) {
                    //trigger.toggle('show')
                    this.timeline.reverse()
                } else {
                    trigger.add('show')
                    this.timeline.restart()
                }
            },
            closeNav(chapter){
                this.timeline.reverse()
                if (chapter > 0) {
                    EventBus.$emit('silentMoveToSection', [chapter]);
                }
            },
            reverseFunction() {
                document.querySelector('#navbarNav').classList.toggle('show');
            },
          moveToSection(chapter, section) {
          /*  let n = 99;
            switch (chapter){
              case 1:
                n = 1;
                break;
              case 4:
                n = 3;
                break;
              case 5:
                n = 5;
                break;
              case 6:
                n = 6;
                break;
              case 7:
                n = 7;
                break;

            }*/
            /*if(this.active >= n){

            }*/
            this.showSideNav = false;
            this.active = chapter;
            EventBus.$emit('moveToSection', [chapter, section]);
          },
          resetActive(){
            let num = this.active;
            this.activeHover = -1;
          },
          setActive(num){
            this.activeHover = num;
          },
          closeModule(){
            window.open('/'+ this.country + '_' + this.lang + '/brand-choice/' ,"_self")
          },
        },
        mounted() {
          this.lang = this.$store.getters.lang;
          this.country = this.$store.getters.country;
            this.timeline = new TimelineMax({onReverseComplete : function () {
                document.querySelector('#navbarNav').classList.toggle('show');
            }})
            this.timeline.from('.bg', 0.25, {yPercent: -100});
            this.timeline.staggerFrom('.nav__item', 0.25, {opacity: 0}, 0.2);
            this.timeline.from('.nav__item--close', 0.25, {opacity: 0});

            this.sound = new Audio('https://www.discover-shiseido.com/Module/Suncare-SS-2020/audio/beachwaves.mp3');

            EventBus.$on('pauseSound', keyword => {
                this.pauseSound(keyword)
            });
        },



    }
</script>

<style scoped>

</style>